import React, { useState, useEffect } from 'react';
import {
	makeStyles,
	Button,
	Box,
	InputAdornment,
	Tabs,
	Tab,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
	Grid,
	MenuItem,
	Radio,
	TextField as TextField2,
} from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import { TextField } from 'formik-material-ui';
import { Field, Form, Formik } from 'formik';
import TitleText from '../components/reusableComponents/TitleText';
import BodyText from '../components/reusableComponents/BodyText';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PhoneIcon from '@material-ui/icons/Phone';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import AccountCircle from '@material-ui/icons/AccountCircle';
// import BodyText from './BodyText';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import BaggageForm from '../components/reusableComponents/BaggageForm';
import { toggleGSTModal, setPayment } from '../reducers/UiReducer';
// import { loginDispatch } from '../reducers/UsersReducer';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import {
	FlightBookDispatch,
	FlightBookEtravDispatch,
	FlightTicketDispatch,
	FlightTicketLCCDispatch,
} from '../reducers/HomeReducer';
import { useSelector } from 'react-redux';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 5,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: 'rgb(239, 51, 57)',
		color: 'white',
		borderRadius: 5,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
}));
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const country = ['Jharkhand', 'Kolkata'];
const visa = [
	'Tourist',
	'Employment',
	'Seamen',
	'Residence',
	'Student',
	'Dependent',
	'Migrant',
];
const title = ['Mr', 'Mrs'];
const FlightSummaryForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	// const [tabvalue, setValue] = React.useState(0);
	const [otp, setOtp] = React.useState(0);
	const location = useLocation();
	const { flightBook, fareQuoteEtrav } = useSelector((state) => state.home);
	const [value, setValue] = React.useState(location.state.formData.value);
	const [value2, setValue2] = React.useState(location.state.formData.value2);
	const [value3, setValue3] = React.useState(location.state.formData.value3);
	const [pass, setPass] = useState(false);
	const [hold, setHold] = useState(false);
	const [pay, setPay] = useState(false);
	const [checked, setChecked] = useState(false);
	const [check, setCheck] = useState(false);
	const [val, setVal] = React.useState(false);
	const [b, setB] = React.useState(false);
	const { selectedOrigin, selectedDepart, payment } = useSelector(
		(state) => state.ui
	);
	const handleCheck = (event) => {
		setCheck(event.target.checked);
	};
	const handleHold = (e) => {
		if (e.target.value === 'hold') {
			dispatch(setPayment(e.target.value));
			if (hold) {
				setHold(false);

				setPay(true);
			} else {
				setHold(true);
				setPay(false);
			}
		} else {
			dispatch(setPayment(e.target.value));
			if (pay) {
				setPay(false);
				setHold(true);
			} else {
				setPay(true);
				setHold(false);
			}
		}
		console.log(e.target.value);
	};
	const handleForm = (e) => {
		if (payment === 'pay') {
			// console.log(formData);
			e.preventDefault();
			var options = {
				key: 'rzp_test_1xufv8E9EKecYL',
				key_secret: 'Ui7h6GeBLYxy1y75QaV6TgBz',
				// amount: location.state.OneflightData.Fare.OfferedFare * 100,
				amount: 500 * 100,
				currency: 'INR',
				name: 'Musafir Bazar',
				description: 'for testing purpose',
				handler: function (response) {
					alert(response.razorpay_payment_id);
					console.log(response);
					// if (response.razorpay_payment_id) {
					// 	if (location.state.OneflightData.IsLCC) {
					// 		dispatch(FlightTicketLCCDispatch(formData, history));
					// 	}

					// 	if (location.state.OneflightData) {
					// 		dispatch(
					// 			FlightBookDispatch(
					// 				formData,
					// 				location.state.OneflightData.ResultIndex,
					// 				location.state.ID,
					// 				history
					// 			)
					// 		);
					// 	}
					// 	if (location.state.flightData) {
					// 		dispatch(
					// 			FlightBookDispatch(
					// 				formData,
					// 				location.state.flightData[0].ResultIndex,
					// 				location.state.ID,
					// 				history
					// 			)
					// 		);
					// 	}
					// 	if (location.state.Returnflight) {
					// 		dispatch(
					// 			FlightBookDispatch(
					// 				formData,
					// 				location.state.Returnflight[0].ResultIndex,
					// 				location.state.ID,
					// 				history
					// 			)
					// 		);
					// 	}
					// }
				},
				prefill: {
					name: `${location.state.formData.data.first_name} ${location.state.formData.data.last_name}`,
					email: location.state.formData.data.email,
					contact: location.state.formData.data.phone,
				},
				notes: {
					address: location.state.formData.data.address,
				},
				theme: {
					color: '#3399cc',
				},
			};
			var pay = new window.Razorpay(options);
			pay.open();
		} else {
			if (location.state.OneflightData.Airline_Code) {
				let formEtrav = {
					Customer_Mobile: '7870075616',
					Passenger_Mobile: location.state.formData.data.phone,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.data.email
						: '',
					PAX_Details: [
						{
							Pax_Id: 1,
							Pax_type: 0,
							Title: location.state.formData
								? location.state.formData.data.title
								: '',
							First_Name: location.state.formData
								? location.state.formData.data.first_name
								: '',
							Last_Name: location.state.formData
								? location.state.formData.data.last_name
								: '',
							Gender: 0,
							Age: null,
							DOB: null,
							Passport_Number: null,
							Passport_Issuing_Country: null,
							Passport_Expiry: null,
							Nationality: null,
							FrequentFlyerDetails: null,
						},
					],
					GST: true,
					GST_Number: '29AADCB2230M1ZP',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: [
						{
							Search_Key: location.state.IDEtrav,
							Flight_Key:
								fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Flight_Key,
							// BookingSSRDetails: [
							// 	{
							// 		Pax_Id: 1,
							// 		SSR_Key:
							// 			'J3jtb85GjGmacPZ2KMq/Fll/JXc2WYpskCI9V0e2/jB19YJkhMxC1Dhl/ro+ac6idc7PcljHd3MDHuvX9XpXxtI+oudpOafRt3vvStGYZUzOQP35YeRQ4Bp9WdjvOgc6MnoX5mTO2vzQomWg0vC23mrMfesLhEuWvbhenHCGmvOJwmTR1lk5a7Y+smMcX+CE7FignZsxNd01ReKIT+ebuwnx7/8GH/eYjvGrQWLkWU53zbtPbvWpcRY8ZAfpVO0/SbD5+S5Ra0x6Fe3vFloe8tWIiCMoKwI6wOLtBQmmY5E2F3DrSgtFPETgLgp2v+rU',
							// 	},
							// 	{
							// 		Pax_Id: 1,
							// 		SSR_Key:
							// 			'BtyQS0cDFeFO19V32F7Xp16vSYN928ncYPXDMvoFEzy8oYSf1+W4Ygo7Vnq2csxVHi9RoESmpAPRU7wqtqOKYq51YfeQJT7E7pleplo0sZmDOWcX+GX+003qHfnYOH1uLt5spc86Qbb7EVvzEipqCr+RSH/AGG/Zwyhym04mlZWWssSFPw2IfHdauLKYkN7NvrGpkztx7XyG//8cgvJkhaMh8Vh4vJllw16N2TESjYyrnBNaEwmgcNFTrFl/BYHKVFFWT3hSzfhbFHSRVEV90op50n0y+0aC2Op8H57xrHEm0Yq6dGv/yVPj4RH8Bnpt8u/jfi+aCLLKlcsKSg1fFtnUURH9JJE3AZEOrmefYUYM+NVZRvprhDJqcs3QqinWxeaG9KjFhbnDw5sTSxvsHI9N4VAGEC8jtJeygtxRgVL0l+01ggySkRukfTqQmJSfX7Ru4pvtCgIuOz8JSPS4pgJNvNfiCUgX001z/9mC71A=',
							// 	},
							// ],
						},
					],
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: 'BOM-MAA  29-Mar-2021  Test API With GST',
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				console.log(formEtrav);
				dispatch(FlightBookEtravDispatch(formEtrav, history, payment));
			} else if (location.state.OneflightData.IsLCC) {
				let formDataLCC = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.data.title
								: '',
							FirstName: location.state.formData
								? location.state.formData.data.first_name
								: '',
							LastName: location.state.formData
								? location.state.formData.data.last_name
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: 'hello',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.data.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.data.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: 'abc',
							GSTCompanyContactNumber: '4564345434',
							GSTCompanyName: 'fffgde',
							GSTNumber: '37AADCS0472N1Z1',
							GSTCompanyEmail: 'fg@gmail.com',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				dispatch(FlightTicketLCCDispatch(formDataLCC, history));
			} else {
				let formData = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					Passengers: [
						{
							Title: location.state.formData
								? location.state.formData.data.title
								: '',
							FirstName: location.state.formData
								? location.state.formData.data.first_name
								: '',
							LastName: location.state.formData
								? location.state.formData.data.last_name
								: '',
							PaxType: 1,
							DateOfBirth: '1987-12-06T00:00:00',
							Gender: 1,
							// PassportNo: location.state.formData
							// 	? location.state.formData.data.passport
							// 	: '',
							// PassportExpiry: '2023-12-06T00:00:00',
							AddressLine1: location.state.formData
								? location.state.formData.data.address
								: '',
							AddressLine2: '',
							Fare: {
								Currency: location.state.OneflightData
									? location.state.OneflightData.Fare.Currency
									: '',
								BaseFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								Tax: location.state.OneflightData
									? location.state.OneflightData.Fare.Tax
									: '',
								YQTax: location.state.OneflightData
									? location.state.OneflightData.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.OneflightData
									? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.OneflightData
									? location.state.OneflightData.Fare.OtherCharges
									: '',
								Discount: location.state.OneflightData
									? location.state.OneflightData.Fare.Discount
									: '',
								PublishedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.PublishedFare
									: '',
								OfferedFare: location.state.OneflightData
									? location.state.OneflightData.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.OneflightData
									? location.state.OneflightData.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.OneflightData
									? location.state.OneflightData.Fare.ServiceFee
									: '',
							},
							City: 'Dhanbad',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.data.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.data.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						},
					],
					Baggage: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Baggage',
							Description: 2,
							Weight: 0,
							Currency: 'INR',
							Price: 5000,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					MealDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							WayType: location.state.body
								? location.state.body.JourneyType
								: '',
							Code: 'No Meal',
							Description: 2,
							AirlineDescription: '',
							Quantity: 1,
							Currency: 'INR',
							Price: 300,
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
						},
					],
					SeatDynamic: [
						{
							AirlineCode: location.state.OneflightData
								? location.state.OneflightData.AirlineCode
								: '',
							FlightNumber: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Airline.FlightNumber;
										})
								: '',
							CraftType: location.state.OneflightData
								? location.state.OneflightData.Segments[0]
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.Craft;
										})
								: '',
							Origin: location.state.body
								? location.state.body.Segments[0].Origin
								: '',
							Destination: location.state.body
								? location.state.body.Segments[0].Destination
								: '',
							AvailablityType: 1,
							Description: 2,
							Code: '2A',
							RowNo: '2',
							SeatNo: 'A',
							SeatType: 1,
							SeatWayType: 2,
							Compartment: 1,
							Deck: 1,
							Currency: 'INR',
							Price: 300,
						},
					],
				};
				dispatch(FlightBookDispatch(formData, history));
			}
		}
	};
	const handleFormSubmit = () => {};
	const edit = () => {
		if (location.state.returnBody) {
			history.push({
				pathname: '/flightsummary',
				state: {
					formData: location.state.formData,
					returnBody: location.state.returnBody,
					Returnflight: location.state.Returnflight,
					flightData: location.state.flightData,
				},
			});
		} else {
			history.push({
				pathname: '/flightsummary',
				state: {
					formData: location.state.formData,
					body: location.state.body,
					OneflightData: location.state.OneflightData,
				},
			});
		}
	};
	function range(start, end) {
		return Array(end)
			.fill()
			.map((_, idx) => start + idx);
	}
	let ad = range(
		0,
		location.state.body
			? location.state.body.AdultCount
			: location.state.returnBody
			? location.state.returnBody.AdultCount
			: ''
	);
	let chld = range(
		0,
		location.state.body
			? location.state.body.ChildCount
			: location.state.returnBody
			? location.state.returnBody.ChildCount
			: ''
	);
	let inft = range(
		0,
		location.state.body
			? location.state.body.InfantCount
			: location.state.returnBody
			? location.state.returnBody.InfantCount
			: ''
	);
	// useEffect(() => {
	// 	if (flightBook) {
	// 		dispatch(
	// 			FlightTicketDispatch(
	// 				location.state.ID,
	// 				flightBook.data.Response.Response.PNR,
	// 				flightBook.data.Response.Response.BookingId
	// 			)
	// 		);
	// 		alert(
	// 			flightBook.data.Response
	// 				? flightBook.data.Response.Error.ErrorMessage
	// 				: 'Ticket Generate Successfully'
	// 		);
	// 	}
	// }, []);
	return (
		<Formik
			initialValues={{
				email: location.state.formData.data.email,
				phone: location.state.formData.data.phone,
				first_name: location.state.formData.data.first_name,
				state: location.state.formData.data.state,
				title: location.state.formData.data.title,
				last_name: location.state.formData.data.last_name,
				passport: location.state.formData.data.passport,
				visatype: location.state.formData.data.visatype,
				address: location.state.formData.data.address,
			}}
			validate={(values) => {
				const errors = {};
				// if (!values.email) {
				// 	errors.email = 'Required';
				// } else if (
				// 	!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
				// ) {
				// 	errors.email = 'Invalid email address';
				// }

				// if (!values.phone) {
				// 	errors.phone = 'Required';
				// }
				// if (!values.first_name) {
				// 	errors.first_name = 'Required';
				// }
				// if (!values.last_name) {
				// 	errors.last_name = 'Required';
				// }
				// if (!values.passport) {
				// 	errors.passport = 'Required';
				// }

				return errors;
			}}
			onSubmit={handleFormSubmit}>
			{({ submitForm, isSubmitting, values, errors }) => (
				<>
					{' '}
					<Form>
						<Box
							className={classes.root}
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							<Box display='flex' alignItems='center'>
								<TitleText
									four
									textStyle={{
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
									}}>
									Contact Details
								</TitleText>
								<BodyText
									four
									textStyle={{
										marginLeft: 20,
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
										// fontSize: 13,
									}}>
									Your booking details will be sent to this email ID & mobile
									number.
								</BodyText>
							</Box>
							<Grid
								container
								spacing={2}
								alignItems='center'
								style={{ marginTop: 20 }}>
								<Grid item xs={12} lg={6}>
									<Field
										component={TextField}
										name='email'
										type='email'
										disabled
										variant='outlined'
										label='Email ID'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
											// startAdornment: (
											// 	<InputAdornment position='start'>
											// 		<AccountCircle />
											// 	</InputAdornment>
											// ),
										}}
										inputProps={{
											style: { padding: 14 },
										}}
									/>
								</Grid>
								<Grid item xs={12} lg={6}>
									<Field
										component={TextField}
										name='phone'
										type='number'
										disabled
										variant='outlined'
										error={errors.phone}
										label='Mobile No.'
										// style={{ marginTop: 20 }}
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
											// startAdornment: (
											// 	<InputAdornment position='start'>
											// 		<PhoneIcon />
											// 	</InputAdornment>
											// ),
										}}
										inputProps={{
											style: { padding: 14 },
										}}
									/>
								</Grid>
							</Grid>
						</Box>
						<Box
							className={classes.root}
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							{/* <Box display='flex' alignItems='center'>
								<TitleText
									four
									textStyle={{
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
									}}>
									Contact Details
								</TitleText>
								<BodyText
									four
									textStyle={{
										marginLeft: 20,
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
									}}>
									Your booking details will be sent to this email ID & mobile
									number.
								</BodyText>
							</Box> */}
							{ad.length > 0 &&
								ad.map((i, index) => {
									return (
										<>
											<Box display='flex'>
												<TitleText two textStyle={{ marginTop: 10 }}>
													{index + 1}
												</TitleText>
												<TitleText
													two
													textStyle={{ marginLeft: 5, marginTop: 10 }}>
													Adult
												</TitleText>
											</Box>
											<Grid
												container
												spacing={2}
												alignItems='center'
												style={{ marginTop: 20 }}>
												<Grid
													item
													xs={12}
													sm={6}
													lg={4}
													style={{ display: 'flex', alignItems: 'center' }}>
													<Field
														component={TextField}
														select
														name='title'
														type='text'
														disabled
														variant='outlined'
														label='Select Title'
														error={errors.title}
														// style={{ marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															className: classes.inputPropsStyle,
														}}>
														{title.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={12} sm={6} lg={4}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														disabled
														label='Enter First Name'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={6} lg={4}>
													<Field
														component={TextField}
														name='last_name'
														type='text'
														variant='outlined'
														disabled
														label='Enter Last Name'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												{/* <Grid
													item
													xs={12}
													sm={6}
													lg={3}
													className={classes.dob}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='DOB'
															disabled
															openTo='year'
															views={['year', 'month', 'day']}
															value={value}
															onChange={(newValue) => {
																setValue(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid> */}
											</Grid>
											<Grid
												container
												spacing={2}
												alignItems='center'
												style={{ marginTop: 10 }}>
												{/* <Grid item xs={2}></Grid> */}
												<Grid item xs={12} sm={6} lg={6}>
													{selectedOrigin &&
													selectedOrigin.country_name === 'India' &&
													selectedDepart &&
													selectedDepart.country_name === 'India' ? (
														''
													) : (
														<Field
															component={TextField}
															name='passport'
															type='text'
															disabled
															variant='outlined'
															label='Enter Passport Number'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 14 },
															}}
														/>
													)}
												</Grid>
												<Grid
													item
													xs={6}
													sm={3}
													lg={3}
													className={classes.passport}>
													{selectedOrigin &&
													selectedOrigin.country_name === 'India' &&
													selectedDepart &&
													selectedDepart.country_name === 'India' ? (
														''
													) : (
														<LocalizationProvider dateAdapter={AdapterDateFns}>
															<DatePicker
																// disableFuture
																label='Expiry Date'
																openTo='year'
																disabled
																views={['year', 'month', 'day']}
																value={value2}
																onChange={(newValue) => {
																	setValue2(newValue);
																}}
																renderInput={(params) => (
																	<TextField2
																		{...params}
																		variant='outlined'
																		name='date'
																		error={errors.date}
																		className={classes.date}
																	/>
																)}
															/>
														</LocalizationProvider>
													)}
												</Grid>
												<Grid
													item
													xs={6}
													sm={3}
													lg={3}
													className={classes.passport}>
													{selectedOrigin &&
													selectedOrigin.country_name === 'India' &&
													selectedDepart &&
													selectedDepart.country_name === 'India' ? (
														''
													) : (
														<LocalizationProvider dateAdapter={AdapterDateFns}>
															<DatePicker
																// disableFuture
																label='Date'
																openTo='year'
																disabled
																views={['year', 'month', 'day']}
																value={value3}
																onChange={(newValue) => {
																	setValue3(newValue);
																}}
																renderInput={(params) => (
																	<TextField2
																		{...params}
																		variant='outlined'
																		name='date'
																		error={errors.date}
																		className={classes.date}
																	/>
																)}
															/>
														</LocalizationProvider>
													)}
												</Grid>
											</Grid>
											<Grid
												container
												spacing={2}
												alignItems='center'
												style={{ marginTop: 10 }}>
												<Grid item xs={12} sm={6} lg={8}>
													{selectedOrigin &&
													selectedOrigin.country_name === 'India' &&
													selectedDepart &&
													selectedDepart.country_name === 'India' ? (
														''
													) : (
														<Field
															component={TextField}
															name='address'
															type='text'
															disabled
															variant='outlined'
															label='Enter Issuing Place'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 14 },
															}}
														/>
													)}
												</Grid>
												<Grid item xs={12} sm={6} lg={4}>
													{selectedOrigin &&
													selectedOrigin.country_name === 'India' &&
													selectedDepart &&
													selectedDepart.country_name === 'India' ? (
														''
													) : (
														<Field
															component={TextField}
															select
															name='visatype'
															type='text'
															disabled
															variant='outlined'
															error={errors.visatype}
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																className: classes.inputPropsStyle,
															}}>
															{visa.map((item, index) => (
																<MenuItem key={index} value={item}>
																	{item}
																</MenuItem>
															))}
														</Field>
													)}
												</Grid>
											</Grid>
										</>
									);
								})}
							{chld.length > 0 &&
								chld.map((i, index) => {
									return (
										<>
											<Box display='flex'>
												<TitleText two textStyle={{ marginTop: 10 }}>
													{index + 1}
												</TitleText>
												<TitleText
													two
													textStyle={{ marginLeft: 5, marginTop: 10 }}>
													Child
												</TitleText>
											</Box>
											<Grid
												container
												spacing={2}
												alignItems='center'
												style={{ marginTop: 20 }}>
												<Grid
													item
													xs={3}
													style={{ display: 'flex', alignItems: 'center' }}>
													<Field
														component={TextField}
														select
														name='title'
														type='text'
														disabled
														variant='outlined'
														label='Select Title'
														error={errors.title}
														// style={{ marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															className: classes.inputPropsStyle,
														}}>
														{title.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														disabled
														label='Enter First Name'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='last_name'
														type='text'
														variant='outlined'
														disabled
														label='Enter Last Name'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															disabled
															openTo='year'
															views={['year', 'month', 'day']}
															value={value}
															onChange={(newValue) => {
																setValue(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={2}
												alignItems='center'
												style={{ marginTop: 10 }}>
												{/* <Grid item xs={2}></Grid> */}
												<Grid item xs={6}>
													<Field
														component={TextField}
														name='passport'
														type='text'
														disabled
														variant='outlined'
														label='Enter Passport Number'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															disabled
															views={['year', 'month', 'day']}
															value={value2}
															onChange={(newValue) => {
																setValue2(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
												<Grid item xs={3}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															disabled
															views={['year', 'month', 'day']}
															value={value3}
															onChange={(newValue) => {
																setValue3(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={8}>
													<Field
														component={TextField}
														name='address'
														type='text'
														disabled
														variant='outlined'
														label='Enter Issuing Place'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														select
														name='visatype'
														type='text'
														disabled
														variant='outlined'
														error={errors.visatype}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															className: classes.inputPropsStyle,
														}}>
														{visa.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
											</Grid>
										</>
									);
								})}
							{inft.length > 0 &&
								inft.map((i, index) => {
									return (
										<>
											<Box display='flex'>
												<TitleText two textStyle={{ marginTop: 10 }}>
													{index + 1}
												</TitleText>
												<TitleText
													two
													textStyle={{ marginLeft: 5, marginTop: 10 }}>
													Infant
												</TitleText>
											</Box>
											<Grid
												container
												spacing={2}
												alignItems='center'
												style={{ marginTop: 20 }}>
												<Grid
													item
													xs={3}
													style={{ display: 'flex', alignItems: 'center' }}>
													<Field
														component={TextField}
														select
														name='title'
														type='text'
														disabled
														variant='outlined'
														label='Select Title'
														error={errors.title}
														// style={{ marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															className: classes.inputPropsStyle,
														}}>
														{title.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														disabled
														label='Enter First Name'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='last_name'
														type='text'
														variant='outlined'
														disabled
														label='Enter Last Name'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															disabled
															openTo='year'
															views={['year', 'month', 'day']}
															value={value}
															onChange={(newValue) => {
																setValue(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
											</Grid>
											<Grid
												container
												spacing={2}
												alignItems='center'
												style={{ marginTop: 10 }}>
												{/* <Grid item xs={2}></Grid> */}
												<Grid item xs={6}>
													<Field
														component={TextField}
														name='passport'
														type='text'
														disabled
														variant='outlined'
														label='Enter Passport Number'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															disabled
															views={['year', 'month', 'day']}
															value={value2}
															onChange={(newValue) => {
																setValue2(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
												<Grid item xs={3}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															disabled
															views={['year', 'month', 'day']}
															value={value3}
															onChange={(newValue) => {
																setValue3(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={8}>
													<Field
														component={TextField}
														name='address'
														type='text'
														disabled
														variant='outlined'
														label='Enter Issuing Place'
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 14 },
														}}
													/>
												</Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														select
														name='visatype'
														type='text'
														disabled
														variant='outlined'
														error={errors.visatype}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															className: classes.inputPropsStyle,
														}}>
														{visa.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
											</Grid>
										</>
									);
								})}
						</Box>
						<Box
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							<Box>
								<Box
									onClick={() => (b ? setB(false) : setB(true))}
									style={{
										padding: '8px 20px',
										// display: inline-flex;
										textalign: 'center',
										backgroundColor: 'rgb(239, 51, 57)',
										color: 'white',
										cursor: 'pointer',
										alignItems: 'center',
										width: '10%',
									}}>
									<BodyText>Baggage</BodyText>
								</Box>
								{b ? (
									<>
										<Box
											mt={'15px'}
											ml={'20px'}
											onMouseEnter={() => setVal(true)}
											onMouseLeave={() => setVal(false)}
											style={{
												display: 'block',
												padding: '6px',
												color: 'dark',
												backgroundColor: val ? '#39c9bb' : 'white',
												border: '1px solid #39c9bb',
												borderRadius: '4px',
												transition: 'all .3s',
												textAlign: 'center',
												width: '12%',
											}}>
											<BodyText>DEL-CCU</BodyText>
										</Box>
										<Box>
											<BaggageForm />
										</Box>
										<BodyText>Total Amount = ₹ 4000</BodyText>
										<BodyText one>
											Note: Pre-booked baggage is 15% cheaper than on-board
											price
										</BodyText>
									</>
								) : (
									''
								)}
							</Box>
						</Box>
						<Box
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							<Box
								display='flex'
								alignItems='center'
								onClick={() => {
									dispatch(toggleGSTModal(true));
								}}>
								<TitleText textStyle={{ color: '#007bff' }}>
									Add GST Details
								</TitleText>
							</Box>
							<Box>
								<BodyText one>
									NOTE: (1) GSTIN can’t be updated once booking is completed.
									(2) Your Taxes may get updated post submitting GST details.
								</BodyText>
							</Box>
						</Box>
						<Box
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							{location.state.OneflightData ? (
								location.state.OneflightData.Airline_Code ? (
									<FormControlLabel
										value='hold'
										control={<Radio checked={hold} onClick={handleHold} />}
										label='Hold'
									/>
								) : location.state.OneflightData.IsLCC ? (
									''
								) : (
									<FormControlLabel
										value='hold'
										control={<Radio checked={hold} onClick={handleHold} />}
										label='Hold'
									/>
								)
							) : (
								''
							)}
							{/* {location.state.OneflightData.IsLCC ? (
								''
							) : (
								<FormControlLabel
									value='hold'
									control={<Radio checked={hold} onClick={handleHold} />}
									label='Hold'
								/>
							)} */}

							<FormControlLabel
								value='pay'
								control={<Radio checked={pay} onClick={handleHold} />}
								label='Pay Online'
							/>
						</Box>

						<Grid container spacing={2}>
							<Grid item xs={2}>
								<Button
									className={classes.createButton}
									onClick={edit}
									style={{ marginTop: 10, fontSize: 14 }}
									disabled={isSubmitting}>
									EDIT
								</Button>
							</Grid>
							<Grid item xs={4}>
								<Button
									className={classes.createButton}
									onClick={handleForm}
									style={{ marginTop: 10, fontSize: 14 }}
									disabled={isSubmitting}>
									PROCESS TO PAYMENT
								</Button>
							</Grid>
							<Grid item xs={4}></Grid>
						</Grid>
					</Form>
				</>
			)}
		</Formik>
	);
};

export default FlightSummaryForm;
